const Content = {
  'expertise': {
    'title': 'Select Clients',
    'clients': [
      {
        'iconName': 'logo-fox'
      },
      {
        'iconName': 'logo-activision'
      },
      {
        'iconName': 'logo-universal'
      },
      {
        'iconName': 'logo-dreamworks'
      },
      {
        'iconName': 'logo-ea'
      },
      {
        'iconName': 'logo-warner-bros'
      },
      {
        'iconName': 'logo-hasbro'
      },
      {
        'iconName': 'logo-lionsgate'
      },
      {
        'iconName': 'logo-paramount'
      },
      {
        'iconName': 'logo-xbox'
      },
      {
        'iconName': 'logo-zynga'
      },
      {
        'iconName': 'logo-stx'
      },
      {
        'iconName': 'logo-sony',
        'iconType': 'IconImage'
      },
      {
        'iconName': 'logo-hulu',
        'iconType': 'IconImage'
      },
      {
        'iconName': 'logo-amazon-video',
        'iconType': 'IconImage'
      },
      {
        'iconName': 'logo-disney',
        'iconType': 'IconImage'
      },
    ]
  }
};

export { Content };
